const badgeSlotSpace = "xsmall";
export {
  badgeSlotSpace
};
